<template>
  <article class="c-card">
    <header class="c-card__header">
      <div class="c-card__leading">
        <h6 class="c-card__title">{{ definitionModule.name }}</h6>
        <span class="meta">{{ $t(definitionModule.type).label }}</span>
      </div>
      <div class="c-card__control">
        <span slot="header-right" :class="definitionModule.module ? 'badge badge--success' : 'badge badge--info'">{{ definitionModule.module ? 'Instalado' : 'Disponível' }}</span>
      </div>
    </header>
    <div class="logo">
      <img :src="definitionModule.logo" alt="logo">
    </div>
    <footer class="c-card__footer u-textLeft">
      <button @click="installModule" href="#" :disabled="definitionModule.module || installing" v-bind:class="buttonClass" class="btn btn--smart btn--sm">
        {{ definitionModule.module ? 'Instalado' : 'Instalar' }}
      </button>
      <a :href="definitionModule.site" target="_blank" class="btn">Ver mais</a>
    </footer>
  </article>
</template>

<script>
  import { mapActions } from 'vuex'
  import notifier from '../../notifier'

  export default {
    data: () => ({
      installing: false
    }),
    methods: {
      ...mapActions('module', [
        'install'
      ]),
      async installModule () {
        this.installing = true

        try {
          await this.install(this.definitionModule)
          notifier.success('Módulo instalado com sucesso!', 'Instalado')
        } catch (err) {
          notifier.error('Falha ao instalar o módulo, tente novamente mais tarde.', 'Não instalado')
        }

        this.installing = false
      }
    },
    computed: {
      buttonClass () {
        return {
          'is-loading': this.installing,
          'btn--success': !this.definitionModule.module,
          'btn--default': this.definitionModule.module
        }
      }
    },
    props: {
      definitionModule: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  .logo
    min-height: 150px
    text-align: center

  .logo > img
    max-height: 50px
    max-width: 80%
</style>



// WEBPACK FOOTER //
// StoreCard.vue?503402db